import * as validationRules from "./validationRules";

export default (validations) => {
  let rules = [];

  Object.entries(validations).forEach(([key, value]) => {
    if (value === undefined) return;

    if (key === "required" && value === false) return;

    if (
      key === "type" &&
      typeof validationRules?.[validations[key]] === "function"
    ) {
      rules.push(validationRules?.[validations[key]](validations));
    }

    if (typeof validationRules?.[key] === "function") {
      rules.push(validationRules?.[key](validations));
    }
  });

  return rules;
};
